// extracted by mini-css-extract-plugin
export default {"appsMenuWrapper":"x2JsiIveaJJoql7hdH99","appsMenu":"Es7wD2jLCAaCcVZdIYu4","skeletonsWrapper":"qnhIaZHj_OvxwETjY3xX"};